/**
 * HomeARDemoInvoicePageContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARDemoInvoicePageContent
 */

import { useHomeARDemoInvoicePageContentLogic } from '@/hooks/traits/useHomeARDemoInvoicePageContentLogic';
import type { HomeARDemoInvoicePageContentConfig } from '@/hooks/traits/useHomeARDemoInvoicePageContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoInvoicePageItem } from '@app/shared';
import { Typography } from '@almadar/ui/components';
import { HomeARDemoInvoicePageStatsView } from '@/components/traits/HomeARDemoInvoicePageStatsView';
import { Split } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { HomeARDemoInvoicePageListView } from '@/components/traits/HomeARDemoInvoicePageListView';
import { HomeARDemoInvoicePageDetailView } from '@/components/traits/HomeARDemoInvoicePageDetailView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeARDemoInvoicePageContentViewProps {
  config?: Partial<HomeARDemoInvoicePageContentConfig>;
}

export function HomeARDemoInvoicePageContentView({ config: propsConfig }: HomeARDemoInvoicePageContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARDemoInvoicePageContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoInvoicePageItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARDemoInvoicePageContent">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="sm" className="p-4"><Typography variant="h3" content={renderPatternValue(__t("std-almadar-demo-invoices-page:page.title"))} /><Split gap="md" ratio="2:3"><Stack gap="sm" direction="vertical"><HomeARDemoInvoicePageStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeARDemoInvoicePageListView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack><HomeARDemoInvoicePageDetailView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeARDemoInvoicePageContentView;
